
<template>
  <div>
    <modal-default ref="thisModal" size="modal-md" v-bind:onsave="close" disableclose="true" buttontext="Close" class="modalmargin">
      <div class="container">
        <div v-for="step in onboardingdata" class="container-fluid wizardpanel animated fadeIn" v-bind:id="'wizardstep' + step.id">
          <div class="row">
            <div class="col-12">
              <onboarding-question v-bind:element="step.question"></onboarding-question>
            </div>
          </div>
          <div v-for="answer in step.answers" class="row">
            <div class="col-12 mt-3">
              <onboarding-answer v-bind:element="answer" @goto="goto"></onboarding-answer>
            </div>
          </div>
          <div class="row" v-show="step.input != null && typeof(step.input) != 'undefined'">
            <div class="col-12 mt-3">
              <onboarding-input v-bind:element="step.input" @goto="goto" @inputclick="inputclickfunction"></onboarding-input>
            </div>
          </div>
          
        </div>
      </div>
      
    </modal-default>
  </div>

</template>

<script>
  var onboardingdata = [
    {
      id: 1,
      question: { text: "Do you usually work with well defined tasks?", animation: "animated duration-1 fadeIn" },
      answers: [
        { text: "Yes, we do", goto: 4, animation: "animated duration-1 rubberBand" },
        { text: "No, we don't", goto: 2, animation: "animated duration-2 tada" },
        { text: "I don't know", goto: 2, animation: "animated duration-3 bounceIn" }
      ]
    },
    {
      id: 2,
      question: { text: "Well, by defining them, you can...", animation: "animated duration-1 heartBeat" },
      answers: [
        { text: "Ok, got it", goto: 4, animation: "animated duration-2 backInDown" },
        { text: "I still don't see what I can get", goto: 3, animation: "animated delay-1 shakeY"}
      ]
    },
    {
      id: 3,
      question: { text: "Usually a task or a team..." },
      answers: [
        { text: "Ok, got it", goto: 4, animation: "animated duration-2 fadeIn"  },
      ]
    },
    {
      id: 4,
      question: { text: "Tell me 3 things you do each day", animation: "animated duration-2 fadeIn" },
      answers: [],
      input: { type:'task', text: "Enter a thing you usually do", suggestions: ["Picking a flower", "Drinking coffee", "Smoking a cigarette"], goto: 5, animation: "animated duration-2 fadeIn" },
      
    },
    {
      id: 5,
      question: { text: "Great!, do you have any tasks that require a team member?" },
      answers: [
        { text: "Yes, there might be something", goto: 6, animation: "animated duration-2 fadeIn" },
        { text: "No, I'm a lone wolf", goto: 10, animation: "animated duration-3 fadeIn" }
      ]
    },
    {
      id: 6,
      question: { text: "Tell us your friends name", animation: "animated duration-1 fadeIn" },
      answers: [],
      input: { type: 'username', text: "Enter a name", suggestions: ["Jose Luis"], goto: 7, animation: "animated duration-2 fadeIn" },
    },
    {
      id: 7,
      question: { text: "Tell us what you want your friend to do" },
      answers: [],
      input: { type: 'taskassigned',  text: "Enter a task", suggestions: ["Give me a hug"], goto: 10 },
    },
    {
      id: 10,
      question: { text: "We are getting tings ready for you", extra: "Hold on...", animation: "animated duration-5 fadeIn mt-3", extraanimation: "animated duration-10 fadeIn mt-4" },
      answers: [],
    }
  ]

  import ModalDefault from "../modals/modal-default.vue";
  import OnBoardingQuestion from "../onboarding/onboarding-question.vue";
  import OnBoardingAnswer from "../onboarding/onboarding-answer.vue";
  import OnBoardingInput from "../onboarding/onboarding-input.vue";


  export default {
    name: 'onboarding',
    components: {
      ModalDefault,
      OnBoardingQuestion,
      OnBoardingAnswer,
      OnBoardingInput
    },
    props: {
      inputclick: {
        required: false,
        type: String,
        default: ''
      },
      state: {
        required: false,
        type: String,
        default: ''
      },

      
    },
    data() {
      return {
        onboardingdata
      }
    },
    methods: {
      inputclickfunction(answer, element) {
        if (this.inputclick != null) {
          eval(this.inputclick + "(answer, element)")
        }
      },
      goto(step) {
        this.activateStep(step);
      },
      activateStep(step) {
        $(".wizardpanel").hide();
        $("#wizardstep" + step).show();

        $("#wizardstep" + step + " .question").addClass("hidden-onboarding");
        $("#wizardstep" + step + " .answer").addClass("hidden-onboarding");
        $("#wizardstep" + step + " .onboardinginput").addClass("hidden-onboarding");

        setTimeout(
          function() {
            $("#wizardstep" + step + " .question").removeClass("hidden-onboarding");
            $("#wizardstep" + step + " .answer").removeClass("hidden-onboarding");
            $("#wizardstep" + step + " .onboardinginput").removeClass("hidden-onboarding");
          }, 200
        )

        
      },
      open() {
        this.$refs.thisModal.open();
      },
      close() {
        this.$refs.thisModal.close();
      }
    },
    created() {

    },
    mounted() {
      if (this.state = 'state') {
        this.open();
      }
      this.activateStep("1")
    }
  }
</script>

<style scoped>
  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }

  .duration-1 {
    animation-duration: 1s;
  }

  .duration-2 {
    animation-duration: 2s;
  }

  .duration-3 {
    animation-duration: 3s;
  }

  .duration-4 {
    animation-duration: 4s;
  }

  .duration-5 {
    animation-duration: 5s;
  }

  .duration-6 {
    animation-duration: 6s;
  }

  .duration-7 {
    animation-duration: 7s;
  }

  .duration-8 {
    animation-duration: 8s;
  }

  .duration-9 {
    animation-duration: 9s;
  }

  .duration-10 {
    animation-duration: 10s;
  }


</style>

<style>
  .hidden-onboarding {
    /*display:none;*/
    opacity: 0;

  }

  .modalmargin .modal-dialog {
    margin-top: 5vh;
    height: 80vh;
    min-height: 75%;
    display: table;
    width: 75%;
  }

  .modalmargin .modal-content {
    height:100%;
    display:inline-table;
  }

  .modalmargin .modal-body {
    display: inline-table;
    height: calc(100% - 70px);
    width:100%
  }

 
  .modalmargin {
    height: 100vh;
  }


  @media (max-width: 768px) {
    .modalmargin {
      margin: 30px !important;
      width: unset !important;
      height: 100vh;
    }
    .modalmargin .modal-dialog {
      height: calc(100vh - 55px) !important;
      width: 100%;
    }
  }

  

</style>



// WEBPACK FOOTER //
// src/components/onboarding/onboarding.vue